module.exports = __webpack_public_path__ + "static/img/mini3.0ee1a653.png";